const bootstrap = require('bootstrap');

import {
    change_selected_folder,
    show_add_inspiration_to_favourites_modal,
    show_create_folder_modal,
    submit_add_inspiration_to_favourites_modal,
    submit_create_folder_modal,
} from './add-to-favourites';
import setup_share_buttons from '../share/share-buttons';

const modal_element_login = document.querySelector('#login-modal');
const modal_element_add_inspiration_to_favourites = document.querySelector('#add-inspiration-modal');
const modal_element_create_folder = document.querySelector('#create-folder-modal');
const modal_element_share_inspiration = document.querySelector('#share-inspiration-modal');

const _show_login_modal = (modal_element) => {
    let login_modal = bootstrap.Modal.getOrCreateInstance(modal_element, {});
    login_modal.show();
};

const default_folder_image =
    modal_element_add_inspiration_to_favourites &&
    modal_element_add_inspiration_to_favourites.querySelector('.dropdown .dropdown-toggle img').getAttribute('src');

document.addEventListener('click', (e) => {
    if (e.target.closest('button.like')) {
        const btn = e.target.closest('button.like');
        const inspiration_id = btn.dataset.inspirationId;
        const inspiration_image_url = btn.dataset.inspirationImageUrl;

        if (modal_element_add_inspiration_to_favourites) {
            show_add_inspiration_to_favourites_modal(
                modal_element_add_inspiration_to_favourites,
                inspiration_id,
                inspiration_image_url,
                default_folder_image
            );
        } else {
            _show_login_modal(modal_element_login);
        }
    }
});

$('.more a').click((e) => {
    let anchor = $(e.target);
    if (anchor.attr('aria-expanded') === 'true')
        anchor.text('Pokaż mniej');
    if (anchor.attr('aria-expanded') === 'false')
        anchor.text('Pokaż więcej');
})

if (modal_element_add_inspiration_to_favourites) {
    modal_element_add_inspiration_to_favourites.addEventListener('click', (e) => {
        if (e.target.closest('button.create-folder-btn')) {

            show_create_folder_modal(modal_element_create_folder);

        } else if (e.target.closest('.dropdown-menu .dropdown-item')) {  // Order is important! Check if it's create folder first.

            e.preventDefault();  // TBF this should have been buttons, not anchors
            let btn = e.target.closest('.dropdown-item');
            change_selected_folder(modal_element_add_inspiration_to_favourites, btn, default_folder_image);

        }
    });

    modal_element_add_inspiration_to_favourites.addEventListener('submit', (e) => {
        e.preventDefault();
        submit_add_inspiration_to_favourites_modal(modal_element_add_inspiration_to_favourites, e.target);
    });
}

if (modal_element_share_inspiration) {
    const _show_share_modal = (modal_element, inspiration_url, title) => {
        let share_input = modal_element.querySelector('#share-inspiration-modal-input');
        if (share_input) {
            share_input.value = inspiration_url;
        }

        modal_element.querySelectorAll('.share-buttons').forEach((container) => {
            setup_share_buttons(container, inspiration_url, title, "https://aboutdecor.pl/storage/inspirations/inspiration/19166/photo/miniature/856-salon-z-bialym-naroznikiem-oraz-bezowym-stolikiem-kawowym.webp");
        });

        const modal = bootstrap.Modal.getOrCreateInstance(modal_element, {});
        modal.show();
    };

    document.addEventListener('click', (e) => {
        if (e.target.closest('button.share')) {
            let btn = e.target.closest('button.share');
            let url = btn.dataset.inspirationPath;
            console.log(url);
            if (navigator.share) {
                navigator.share({
                    title: document.title,
                    url: url,
                });
            } else {
                _show_share_modal(modal_element_share_inspiration, url, document.title);
            }
        }
    });

    modal_element_share_inspiration.addEventListener('click', (e) => {
        if (e.target.closest('button.clipboard-link')) {
            let input = modal_element_share_inspiration.querySelector('#share-inspiration-modal-input');
            input.select();
            input.setSelectionRange(0, 99999);

            document.execCommand('copy');
        }
    });
}

if (modal_element_create_folder) {
    modal_element_create_folder.addEventListener('submit', (e) => {
        if (e.target.matches('form:not([method])')) {
            e.preventDefault();
            submit_create_folder_modal(
                modal_element_create_folder,
                modal_element_add_inspiration_to_favourites,
                e.target
            );
        }
    });
}


